import { render, staticRenderFns } from "./updates-banner-component.vue?vue&type=template&id=3a791b42"
import script from "./updates-banner-component.vue?vue&type=script&lang=js"
export * from "./updates-banner-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports